// Helpers de apresentação do catálogo (SEM foto — a UI é linda por tipografia,
// cor por categoria e um monograma/emoji sóbrio derivado do nome).

import { normalizeText } from './format';
import type { Cardapio } from './api';

// 6 acentos quentes que ciclam por categoria (var(--accent-N) no CSS).
const ACCENTS = 6;

export function accentVar(index: number): string {
  return `var(--accent-${(index % ACCENTS) + 1})`;
}

// Monograma: primeira letra "forte" do nome do produto (fallback ponto).
export function monograma(nome: string): string {
  const ch = String(nome ?? '').trim().charAt(0);
  return ch ? ch.toUpperCase() : '•';
}

// Emoji sóbrio por palavra-chave no nome da CATEGORIA. Puramente decorativo e
// opcional; nunca é a única forma de identificar a categoria (há texto + cor).
// Regras avaliadas em ORDEM (a 1ª que casar vence); os alvos já vêm normalizados
// (sem acento, minúsculo). Fronteira só à ESQUERDA (\b) + radical, para casar
// singular e plural ("bebida" casa "bebidas", "suco" casa "sucos").
const EMOJI_RULES: ReadonlyArray<readonly [RegExp, string]> = [
  // Antes de "cafe": café da manhã / padaria é 🥐, não ☕.
  [/\b(cafe da manha|pao|padaria|tapioca|croissant)/, '🥐'],
  [/\b(bebida|drink|suco|refri|agua|cerveja|chopp|vinho|cha\b)/, '🥤'],
  [/\b(cafe|capuccino|expresso|espresso)/, '☕'],
  [/\b(sobremesa|doce|torta|bolo|pudim|sorvete|aca)/, '🍰'],
  [/\b(pizza)/, '🍕'],
  [/\b(hamburg|burguer|burger|lanche|sandui)/, '🍔'],
  [/\b(porcao|porcoes|petisco|aperitiv)/, '🍟'],
  [/\b(salada|vegetari|vegan)/, '🥗'],
  [/\b(massa|macarr|pasta|nhoque|espaguete)/, '🍝'],
  [/\b(carne|churrasc|grelhad|parrilla|espeto)/, '🥩'],
  [/\b(peixe|frutos do mar|camarao|sushi|sashimi|japon)/, '🍣'],
  [/\b(prato|executivo|almoco|jantar|refeic)/, '🍽️'],
  [/\b(combo|promo)/, '⭐'],
];

export function categoriaEmoji(nome: string): string {
  const n = normalizeText(nome);
  for (const [re, emoji] of EMOJI_RULES) {
    if (re.test(n)) return emoji;
  }
  return '🍴';
}

// Total de itens no cardápio (para o rodapé / vazio).
export function totalItens(cardapio: Cardapio): number {
  return cardapio.categorias.reduce((acc, c) => acc + c.produtos.length, 0);
}
